import { useMutation } from '@apollo/client';
import { UpdateToolOrderInput } from '@bechtel/ht-types';
import { UPDATE_TOOL_ORDER } from '~/gql/tool-order';
import { ToolOrderInputData, ToolOrderPayloadData } from '~/views/reservations/types';

export const useUpdateToolOrder = () => {
  const [updateDraftOrderMutation, { data, loading, error }] = useMutation<ToolOrderPayloadData, ToolOrderInputData>(
    UPDATE_TOOL_ORDER
  );

  const updateToolOrder = (
    input: UpdateToolOrderInput,
    onCompleted?: (data: any) => void,
    onError?: (data: any) => void,
    refetchQueries: string[] = ['SearchToolOrders', 'ToolOrderStats', 'GetToolOrderHistory']
  ) => {
    updateDraftOrderMutation({
      variables: {
        updateToolOrderInput: input,
      },
      onCompleted: (data) => {
        onCompleted && onCompleted(data);
      },
      onError: (data) => {
        onError && onError(data);
      },
      refetchQueries: refetchQueries,
    });
  };

  return { updateToolOrder, data, loading, error };
};
